import {Component, Input, inject, OnInit} from '@angular/core';
import {TranslationService} from "../../../../core/services/translation.service";
import {HupSubscription} from "../../../../data/models/subscription.model";
import { DatePipe } from "@angular/common";
import {ConfigService} from '../../../../core/services/config.service';

@Component({
  selector: 'app-product-variant-period-block',
  templateUrl: './product-variant-period-block.component.html',
  styleUrls: ['./product-variant-period-block.component.css'],
  imports: [
    DatePipe
],
  providers: [
    DatePipe
  ],
  standalone: true
})
export class ProductVariantPeriodBlockComponent implements OnInit {
  translationService = inject(TranslationService);
  private configService = inject(ConfigService);

  @Input() subscription: HupSubscription
  today: Date = new Date();
  showProductDescription: boolean = true;
  showVariantDescription: boolean = true;
  showOrderNo: boolean = false;

  ngOnInit(): void {
    this.showProductDescription = this.configService.getConfig('subscription.showProductDescription')?.asBoolean();

    this.showOrderNo = this.configService.getConfig('subscription.showOrderNo')?.asBoolean();

    this.showVariantDescription = this.configService.getConfig('subscription.showVariantDescription')?.asBoolean();
  }
}
